(function () {
  var selectionStorageKey = 'nurturedFreeGiftSelection';

  function saveGiftSelection(form) {
    var selectedGift = form.querySelector('input[name="contact[Free mini choice]"]:checked');
    if (!selectedGift || !selectedGift.dataset.freegiftProductImage) return;

    try {
      sessionStorage.setItem(
        selectionStorageKey,
        JSON.stringify({
          name: selectedGift.value,
          image: selectedGift.dataset.freegiftProductImage
        })
      );
    } catch (error) {
      // Submission can continue when browser storage is unavailable.
    }
  }

  function showGiftSelection(section) {
    var rewardImage = section.querySelector('[data-freegift-reward-image]');
    if (!rewardImage) return;

    try {
      var selection = JSON.parse(sessionStorage.getItem(selectionStorageKey));
      if (!selection || !selection.image) return;

      rewardImage.src = selection.image;
      rewardImage.alt = selection.name || 'Selected free mini product';
      rewardImage.hidden = false;
    } catch (error) {
      // Leave the image area empty if no valid selection can be restored.
    }
  }

  function getBackendRoot() {
    var host = document.querySelector(
      '[id$="__freegift_forms_backend"] shopify-forms-embed'
    );
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  function waitForBackendRoot(attempt) {
    return new Promise(function (resolve, reject) {
      var root = getBackendRoot();
      if (root) {
        resolve(root);
        return;
      }

      if (attempt >= 50) {
        reject(new Error('The feedback service is unavailable.'));
        return;
      }

      window.setTimeout(function () {
        waitForBackendRoot(attempt + 1).then(resolve, reject);
      }, 100);
    });
  }

  function setControlValue(control, value) {
    if (!control) return;

    var prototype =
      control.tagName === 'TEXTAREA'
        ? window.HTMLTextAreaElement.prototype
        : window.HTMLInputElement.prototype;
    var valueSetter = Object.getOwnPropertyDescriptor(prototype, 'value');

    if (valueSetter && valueSetter.set) {
      valueSetter.set.call(control, value);
    } else {
      control.value = value;
    }

    control.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    control.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }

  function selectBackendChoice(root, name, accessibleName) {
    var choices = root.querySelectorAll('input[name="' + name + '"]');

    Array.prototype.forEach.call(choices, function (choice) {
      if (
        choice.getAttribute('aria-label') === accessibleName &&
        !choice.checked
      ) {
        choice.click();
      }
    });
  }

  function setBackendCheckbox(root, name, checked) {
    var checkbox = root.querySelector('input[name="' + name + '"]');
    if (checkbox && checkbox.checked !== checked) checkbox.click();
  }

  function selectBackendProduct(root, productName) {
    return new Promise(function (resolve, reject) {
      var toggle = root.querySelector(
        'button[aria-labelledby^="custom#product_purchased-selector-label"]'
      );
      var selectedValue = root.querySelector(
        '#custom\\#product_purchased-selector-value'
      );

      if (!toggle) {
        reject(new Error('The product selection service is unavailable.'));
        return;
      }

      if (
        selectedValue &&
        selectedValue.textContent.trim() === productName
      ) {
        resolve();
        return;
      }

      toggle.click();

      window.setTimeout(function () {
        var option = Array.prototype.find.call(
          root.querySelectorAll('[role="option"]'),
          function (item) {
            return item.textContent.trim() === productName;
          }
        );

        if (!option) {
          reject(new Error('The selected product could not be confirmed.'));
          return;
        }

        option.click();

        window.setTimeout(function () {
          var confirmedValue = root.querySelector(
            '#custom\\#product_purchased-selector-value'
          );

          if (
            confirmedValue &&
            confirmedValue.textContent.trim() === productName
          ) {
            resolve();
          } else {
            reject(new Error('The selected product could not be confirmed.'));
          }
        }, 0);
      }, 0);
    });
  }

  function showSubmissionError(form, message) {
    var error = form.querySelector('[data-freegift-form-error]');
    var submit = form.querySelector('.freegift-form__submit');

    if (error) {
      error.textContent =
        message ||
        'We could not submit your feedback. Please check the form and try again.';
      error.hidden = false;
      error.focus();
    }

    if (submit) {
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
    }
  }

  function showSuccess(section, form) {
    var content = form.querySelector('[data-freegift-form-content]');
    var success = form.querySelector('[data-freegift-success]');

    if (content) content.hidden = true;
    if (success) {
      success.hidden = false;
      success.focus();
    }

    section.classList.add('freegift-page--submitted');
    showGiftSelection(section);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function submitPublicReview(form) {
    var section = form.closest('[data-freegift-section]');
    var reviewConsent = form.querySelector(
      'input[name="public_review_consent"]'
    );
    if (!reviewConsent || !reviewConsent.checked) return;

    var name = form.querySelector('#FreeGift-name').value.trim();
    var email = form.querySelector('#FreeGift-email').value.trim();
    var comments = form.querySelector('#FreeGift-comments').value.trim();
    var rating = form.querySelector('input[name="contact[Rating]"]:checked');
    var reviewBody =
      comments +
      "\n\nDisclosure: Feedback collected through Nurtured Skincare's free-mini feedback program.";
    var payload = new URLSearchParams({
      shop_domain: 'arsjwe-vz.myshopify.com',
      platform: 'shopify',
      id: (section && section.dataset.freegiftReviewProductId) || '8822999187611',
      name: name,
      email: email,
      rating: rating.value,
      body: reviewBody,
      title: (section && section.dataset.freegiftReviewTitle) || 'Post-Shave Oil feedback'
    });

    fetch('https://judge.me/api/v1/reviews', {
      method: 'POST',
      mode: 'no-cors',
      credentials: 'omit',
      keepalive: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: payload.toString()
    }).catch(function () {
      // Private feedback and gift eligibility are never blocked by review publishing.
    });
  }

  function notifyLowRating(form) {
    var section = form.closest('[data-freegift-section]');
    var rating = form.querySelector('input[name="contact[Rating]"]:checked');
    if (!rating || Number(rating.value) > 3) return;

    var name = form.querySelector('#FreeGift-name').value.trim();
    var email = form.querySelector('#FreeGift-email').value.trim();
    var comments = form.querySelector('#FreeGift-comments').value.trim();
    var gift = form.querySelector(
      'input[name="contact[Free mini choice]"]:checked'
    );
    var payload = new URLSearchParams({
      form_type: 'contact',
      utf8: '\u2713',
      'contact[name]': name,
      'contact[email]': email,
      'contact[body]':
        ((section && section.dataset.freegiftLowRatingSubject) || 'Post-Shave Oil free-gift feedback alert') +
        '\n\nRating: ' +
        rating.value +
        '/5\nSelected mini: ' +
        gift.value +
        '\n\nComments:\n' +
        comments
    });

    fetch('/contact#contact_form', {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: payload.toString()
    }).catch(function () {
      // The original feedback remains saved if the alert cannot be sent.
    });
  }

  function observeBackendResult(root, section, form) {
    var completed = false;
    var backendForm = root.querySelector('form');
    var observer = new MutationObserver(function () {
      var text = (root.textContent || '').replace(/\s+/g, ' ').trim();
      var normalizedText = text.toLowerCase();
      var backendFormWasReplaced =
        backendForm && !backendForm.isConnected;
      var successMessageIsVisible =
        normalizedText.indexOf('thank you') !== -1 &&
        (normalizedText.indexOf('free mini') !== -1 ||
          normalizedText.indexOf('feedback') !== -1);

      if (
        !completed &&
        (backendFormWasReplaced || successMessageIsVisible)
      ) {
        completed = true;
        observer.disconnect();
        notifyLowRating(form);
        submitPublicReview(form);
        showSuccess(section, form);
        return;
      }

      var alert = root.querySelector('[role="alert"]');
      if (alert && alert.textContent.trim()) {
        completed = true;
        observer.disconnect();
        showSubmissionError(form, alert.textContent.trim());
      }
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });

    window.setTimeout(function () {
      if (!completed) {
        observer.disconnect();
        showSubmissionError(
          form,
          'Your feedback could not be confirmed. Please try submitting again.'
        );
      }
    }, 20000);
  }

  function submitToShopifyForms(root, section, form) {
    var name = form.querySelector('#FreeGift-name').value.trim();
    var email = form.querySelector('#FreeGift-email').value.trim();
    var product = form.querySelector('#FreeGift-product').value;
    var comments = form.querySelector('#FreeGift-comments').value.trim();
    var rating = form.querySelector('input[name="contact[Rating]"]:checked');
    var gift = form.querySelector(
      'input[name="contact[Free mini choice]"]:checked'
    );
    var usEligibility = form.querySelector(
      'input[name="contact[US eligibility confirmed]"]'
    );
    var reviewConsent = form.querySelector(
      'input[name="public_review_consent"]'
    );
    var marketingConsent = form.querySelector(
      'input[name="contact[Marketing consent]"]'
    );
    var storedComments =
      comments +
      '\n\n[Public review consent: ' +
      (reviewConsent.checked ? 'Yes' : 'No') +
      ']';

    setControlValue(root.querySelector('#first_name'), name);
    setControlValue(root.querySelector('#email'), email);
    setControlValue(
      root.querySelector('textarea[name="custom#comments"]'),
      storedComments
    );

    selectBackendChoice(
      root,
      'custom#rating',
      rating.value === '1' ? '1 star' : rating.value + ' stars'
    );
    selectBackendChoice(
      root,
      'custom#choose_your_free_mini',
      gift.value
    );
    setBackendCheckbox(
      root,
      'custom#us_eligibility',
      usEligibility.checked
    );

    var backendMarketingConsent =
      root.querySelector('input[name="accepts_marketing"]') ||
      root.querySelector('input[name*="marketing"]') ||
      root.querySelector('input[type="checkbox"][aria-label*="news" i]') ||
      root.querySelector('input[type="checkbox"][aria-label*="offers" i]');

    if (
      backendMarketingConsent &&
      backendMarketingConsent.checked !== marketingConsent.checked
    ) {
      backendMarketingConsent.click();
    }

    return selectBackendProduct(root, product).then(function () {
      var submit = Array.prototype.find.call(
        root.querySelectorAll('button[type="submit"]'),
        function (button) {
          return button.textContent.trim() === 'Submit & claim my gift';
        }
      );

      if (!submit) throw new Error('The feedback service is unavailable.');

      observeBackendResult(root, section, form);
      submit.click();
    });
  }

  function initFreeGiftPage(section) {
    if (!section || section.dataset.freegiftReady === 'true') return;
    section.dataset.freegiftReady = 'true';

    var form = section.querySelector('#FreeGiftFeedbackForm');
    if (!form) return;

    var giftChoices = form.querySelectorAll(
      'input[name="contact[Free mini choice]"]'
    );

    giftChoices.forEach(function (giftChoice) {
      giftChoice.addEventListener('change', function () {
        saveGiftSelection(form);
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      saveGiftSelection(form);

      var error = form.querySelector('[data-freegift-form-error]');
      var submit = form.querySelector('.freegift-form__submit');

      if (error) error.hidden = true;
      if (submit) {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
      }

      waitForBackendRoot(0)
        .then(function (root) {
          return submitToShopifyForms(root, section, form);
        })
        .catch(function (error) {
          showSubmissionError(form, error.message);
        });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-freegift-section]').forEach(initFreeGiftPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFreeGiftPage(event.target.querySelector('[data-freegift-section]'));
  });
})();
